<h2 mat-dialog-title> Añadir clasificado</h2>
<mat-dialog-content>

  @if (showProgressBar) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <div class='mat-dialog-content1'>
    <form [formGroup]="form">
      <mat-form-field appearance="fill" class='formField'>
        <mat-label>Material</mat-label>
        <mat-select formControlName="materiall" required [(value)]="materiall">
          @for (material of materiales; track material) {
            <mat-option [value]="material.id">{{material.nombre}}</mat-option>
          }
        </mat-select>
        <mat-error>Debes seleccionar un material.</mat-error>
      </mat-form-field>
      <mat-form-field appearance="fill" class='formField'>
        <mat-label>Peso</mat-label>
        <input matInput placeholder="Peso" formControlName="peso" type='number' required>
      </mat-form-field>
      <mat-form-field appearance="fill" class='formField'>
        <mat-label>Observaciones</mat-label>
        <input matInput placeholder="Observaciones" formControlName="observaciones">
      </mat-form-field>
      <mat-form-field appearance="fill" class='formField'>
        <mat-label>Foto 1</mat-label>
        <input matInput type="file" accept="image/*" (change)="onFileSelected($event, 'foto1')">
      </mat-form-field>
      <mat-form-field appearance="fill" class='formField'>
        <mat-label>Foto 2</mat-label>
        <input matInput type="file" accept="image/*" (change)="onFileSelected($event, 'foto2')">
      </mat-form-field>
    </form>
  </div>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancelar</button>
  <button mat-button (click)="save()">Guardar</button>
</mat-dialog-actions>
